export const getSearchOptions = (language = 'en') => {
  switch (language) {
    //Latin
    case 'es': {
      return {
        encode: 'simple',
        tokenize: 'forward'
      };
    }
    //Arabic, Hebrew
    case 'ar':
    case 'he': {
      return {
        encode: false,
        rtl: true,
        split: /\s+/,
        tokenize: 'forward'
      };
    }
    //Cyrillic, Indian
    case 'az':
    case 'sr':
    case 'uz': {
      return {
        encode: false,
        split: /\s+/,
        tokenize: 'forward'
      };
    }
    //Chinese, Japanese, Korean
    case 'zh':
    case 'ja':
    case 'ko': {
      return {
        encode: false,
        tokenize: str => {
          // eslint-disable-next-line no-control-regex
          return str.replace(/[\x00-\x7F]/g, '').split('');
        }
      };
    }
    default: {
      return {
        encode: 'balance',
        tokenize: 'full'
      };
    }
  }
};
